import React from 'react';
import PropTypes from 'prop-types';
import LoginFormHeader from '../../Components/LoginFormHeader';
import RegisterFormContent from './RegisterFormContent';

function RegisterModalForm(props) {
  const { ipAddress, isAnonymousUser, selfClose } = props;

  return (
    <div className="login-form login-page-form-wrapper register-form">
      <LoginFormHeader ipAddress={ipAddress} isAnonymousUser={isAnonymousUser} cancel={selfClose} actionMessage="Create account" />
      <RegisterFormContent {...props} isUsernameVisible={false} />
    </div>
  );
}

RegisterModalForm.propTypes = {
  isAnonymousUser: PropTypes.bool,
  selfClose: PropTypes.func.isRequired,
  ipAddress: PropTypes.string,
};

export default RegisterModalForm;
